function getPlayersByUUID(uuid) {
  return window.VidyardV4.players.filter((player) => player.uuid === uuid);
}

export default getPlayersByUUID;
